import BranchWiseFetchDetailsTypes from './BranchWiseFetchDetails.types';

export const branchWiseFetchStart = (data: any) => ({
	type: BranchWiseFetchDetailsTypes.BRANCH_WISE_FETCH_START,
	payload: data,
});

export const branchWiseFetchSuccess = (data: any) => ({
	type: BranchWiseFetchDetailsTypes.BRANCH_WISE_FETCH_SUCCESS,
	payload: data,
});

export const branchWiseFetchFailure = (error: unknown) => ({
	type: BranchWiseFetchDetailsTypes.BRANCH_WISE_FETCH_FAILURE,
	payload: error,
});

export const branchWiseFetchResponseChanged = () => ({
	type: BranchWiseFetchDetailsTypes.BRANCH_WISE_FETCH_RESPONSE_CHANGED,
});

export const branchWiseFetchResponseRestStart = () => ({
	type: BranchWiseFetchDetailsTypes.BRANCH_WISE_FETCH_RESPONSE_REST_START,
});
